import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose'

const ButtonClose = ({ type = 'button', title = 'Close', onClick }) => {
	return (
		<button className="btn secondary" type={type} onClick={onClick}>
			<AiOutlineClose />
			<span>{title}</span>
		</button>
	)
}

export default ButtonClose
